// ======================================================================
// ImsPage.filters.js
// Filtri e intestazioni personalizzate per IMS Grid
// ======================================================================

import React from "react";
import Select from "react-select";
import { TableFilterRow, TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";
import { selectStyles } from "./ImsPage.utils";

// ======================================================================
// FILTRO AVANZATO PER OGNI COLONNA
// Personalizza il filtro in base al tipo di colonna:
// - Prodotto: multi-select con react-select
// - Regione / Prov: multi-select
// - Trend: select (▲, ▼, =)
// - Quantità/Diff: input numerico
// - default: input testuale
// ======================================================================
export const AdvancedFilterCell = (props) => {
  const { column, filter, onFilter } = props;
  const { regionOptions, provOptions, skuOptions, monthYearOptions, ...cellProps } = props;

  if (column.name === "productName") {
    return (
      <TableFilterRow.Cell {...cellProps}>
        <Select
          isMulti
          options={skuOptions || []}
          value={
            skuOptions?.filter((opt) => {
              if (!filter?.value) return false;
              return filter.value.split(",").includes(opt.label);
            }) || []
          }
          onChange={(selected) => {
            const labels = selected?.map((opt) => opt.label) || [];
            onFilter(labels.length > 0 ? { value: labels.join(",") } : null);
          }}
          placeholder="Prodotto"
          className="react-select text-center"
          classNamePrefix="react-select"
          menuPortalTarget={document.body}
          styles={selectStyles}
          noOptionsMessage={() => "Tutti"}
        />
      </TableFilterRow.Cell>
    );
  }

  if (column.name === "regione") {
    return (
      <TableFilterRow.Cell {...cellProps}>
        <Select
          isMulti
          options={regionOptions || []}
          value={
            regionOptions?.filter((opt) => {
              if (!filter?.value) return false;
              return filter.value.split(",").includes(opt.value);
            }) || []
          }
          onChange={(selected) => {
            const values = selected?.map((opt) => opt.value) || [];
            onFilter(values.length > 0 ? { value: values.join(",") } : null);
          }}
          placeholder="-"
          className="react-select text-center"
          classNamePrefix="react-select"
          menuPortalTarget={document.body}
          styles={selectStyles}
          noOptionsMessage={() => "Nessuna regione"}
        />
      </TableFilterRow.Cell>
    );
  }

  if (column.name === "prov") {
    return (
      <TableFilterRow.Cell {...cellProps}>
        <Select
          isMulti
          options={provOptions || []}
          value={
            provOptions?.filter((opt) => {
              if (!filter?.value) return false;
              return filter.value.split(",").includes(opt.value);
            }) || []
          }
          onChange={(selected) => {
            const values = selected?.map((opt) => opt.value) || [];
            onFilter(values.length > 0 ? { value: values.join(",") } : null);
          }}
          placeholder="-"
          className="react-select text-center"
          classNamePrefix="react-select"
          menuPortalTarget={document.body}
          styles={selectStyles}
          noOptionsMessage={() => "Nessuna provincia"}
        />
      </TableFilterRow.Cell>
    );
  }

  if (column.name === "trend") {
    const trendOptions = [
      { value: "positive", label: "\u25B2" },
      { value: "negative", label: "\u25BC" },
      { value: "neutral", label: "=" },
    ];

    return (
      <TableFilterRow.Cell {...cellProps}>
        <Select
          options={trendOptions}
          value={trendOptions.find((opt) => filter?.value === opt.value) || null}
          onChange={(selected) => onFilter(selected ? { value: selected.value } : null)}
          placeholder="-"
          className="react-select containerTrend"
          classNamePrefix="react-select"
          menuPortalTarget={document.body}
          styles={selectStyles}
          isClearable
        />
      </TableFilterRow.Cell>
    );
  }

  if (column.name.startsWith("qty_") || column.name === "diff") {
    return (
      <TableFilterRow.Cell {...cellProps}>
        <input
          type="number"
          value={filter?.value || ""}
          onChange={(e) => onFilter(e.target.value ? { value: e.target.value } : null)}
          className="form-control form-control-sm"
          placeholder="Minimo valore"
          style={{ fontSize: "0.875rem", width: "100%" }}
        />
      </TableFilterRow.Cell>
    );
  }

  if (column.name === "actions") {
    return (
      <TableFilterRow.Cell {...cellProps}>
        <span />
      </TableFilterRow.Cell>
    );
  }

  return (
    <TableFilterRow.Cell {...cellProps}>
      <input
        type="text"
        value={filter?.value || ""}
        onChange={(e) => onFilter(e.target.value ? { value: e.target.value } : null)}
        className="form-control form-control-sm"
        placeholder="Cerca..."
        style={{ fontSize: "0.875rem", width: "100%" }}
      />
    </TableFilterRow.Cell>
  );
};

// ======================================================================
// INTESTAZIONE CENTRATA SU 2 RIGHE
// ======================================================================
export const CustomHeaderCell = ({ column, children }) => (
  <TableHeaderRow.Cell column={column} style={{ padding: 0 }}>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        fontWeight: "bold",
        textAlign: "center",
        wordWrap: "break-word",
        whiteSpace: "normal",
      }}
    >
      {children}
    </div>
  </TableHeaderRow.Cell>
);
